import { LazyIssueApp } from '@atlassian/jira-lazy-issue-app/src/LazyIssueApp.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { softwareCapacityClassicRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareCapacityClassicRoute.tsx';
import { classicSoftwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarSoftwareClassic from '@atlassian/jira-navigation-apps-sidebar-software-classic/src/async.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { projectThemeResource } from '@atlassian/jira-router-resources-project-theme/src/index.tsx';
import { getIsSoftwareThemingEnabled } from '@atlassian/jira-project-theme-providers/src/utils/getIsSoftwareThemingEnabled.tsx';
import { CapacitySkeleton } from '@atlassian/jira-skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { softwareCapacityRouteEntry } from './ui/software/capacity/index.tsx';

export const softwareCapacityClassicRouteEntry = createEntry(softwareCapacityClassicRoute, () => ({
	afterPaint: [LazyIssueApp],
	bifrost: {
		bifrostGroup: 'shell-only',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-classic-projects-entries/src/softwareCapacityClassicRouteEntry.tsx',
			whichExportToUse: 'softwareCapacityClassicRouteEntry',
		},
		enabled: true,
	},
	component: CapacitySkeleton,
	entryPoint: () => {
		if (__SERVER__) {
			return undefined;
		}
		return softwareCapacityRouteEntry;
	},
	forPaint: [LazyAtlassianNavigation],
	group: 'classic-software',
	layout: classicSoftwareProjectLayout,
	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarSoftwareClassic,
		horizontal: AsyncHorizontalNavJira,
		sidebarId: SIDEBAR_ID.CONTENT,
	},
	resources: [
		...getNavigationResources(), // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		staticSidebarShortcutsResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		resourceWithCondition(() => getIsSoftwareThemingEnabled(), projectThemeResource),
	],
	skeleton: CapacitySkeleton,
	supportsPreviewPanel: true,
	ufoName: 'classic-capacity',
}));
